import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {GeneralTranslation} from "../../generated/translation-client";

@Injectable({
  providedIn: 'root'
})
export class SharedUtilService {
  public translationNamespacesLoaded: { [language: string]: { [namespace: string]: Observable<GeneralTranslation> | boolean }; } = {};
}
